import { render, staticRenderFns } from "./CuotasVencidas.vue?vue&type=template&id=7020841e"
import script from "./CuotasVencidas.vue?vue&type=script&lang=js"
export * from "./CuotasVencidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports